/**
 * The Reluxe - Shipping Protection Integration
 * Product ID: 9096660156638
 *
 * IMPORTANT: This script must be loaded AFTER the theme's cart scripts
 */

const ShippingProtection = {
  variants: {
    5: '47819347132638',
    10: '47819347165406',
    20: '47819347198174',
    25: '47819347230942',
    35: '47819347263710',
    40: '47819347296478'
  },

  maxCoverage: 3000,
  isProcessing: false,
  isInitializing: false,
  lastAddToCartTime: 0,
  protectionVariantIds: ['47819347132638', '47819347165406', '47819347198174', '47819347230942', '47819347263710', '47819347296478'],

  getFeeForCart(cartTotal) {
    if (cartTotal < 500) return 5;
    if (cartTotal < 1000) return 10;
    if (cartTotal < 2300) return 20;
    if (cartTotal < 3500) return 25;
    if (cartTotal < 4500) return 35;
    return 40;
  },

  getCartTotalWithoutProtection(cart) {
    let total = 0;
    cart.items.forEach(item => {
      if (!this.isProtectionItem(item)) {
        total += item.final_line_price;
      }
    });
    return total / 100;
  },

  isProtectionItem(item) {
    return item.title.includes('Shipping Protection') ||
           this.protectionVariantIds.includes(String(item.variant_id));
  },

  getProtectionInCart(cart) {
    return cart.items.find(item => this.isProtectionItem(item));
  },

  getProtectionIndex(cart) {
    return cart.items.findIndex(item => this.isProtectionItem(item));
  },

  getRealItemCount(cart) {
    return cart.items.filter(item => !this.isProtectionItem(item)).length;
  },

  async addProtection(variantId) {
    this.isProcessing = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      });
      this.isProcessing = false;
      return res.ok ? await res.json() : null;
    } catch (e) {
      this.isProcessing = false;
      return null;
    }
  },

  async removeProtection(key) {
    this.isProcessing = true;
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      this.isProcessing = false;
      return res.ok ? await res.json() : null;
    } catch (e) {
      this.isProcessing = false;
      return null;
    }
  },

  renderUI(fee, isChecked) {
    return `
      <div class="shipping-protection-wrapper" id="shipping-protection">
      
        <div class="shipping-protection-row">
          <label class="shipping-protection-label">
            <input type="checkbox" id="protection-checkbox" ${isChecked ? 'checked' : ''}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#888" stroke-width="2">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            </svg>
            <span>Shipping Protection</span>
            <button type="button" class="protection-help-btn" id="protection-help-btn">?</button>
          </label>
          <span class="protection-price">$${fee.toFixed(2)}</span>
        </div>
      </div>
      <div class="protection-modal-overlay" id="protection-modal">
        <div class="protection-modal">
        <center>
          <button type="button" class="protection-modal-close" id="protection-modal-close">&times;</button>
          <h3>Protect Your Order</h3>
          <p>Deselecting shipping protection means The Reluxe is not responsible for lost, damaged, or stolen items during transit.</p>
          
          <a href="/pages/shipping-protection-terms" class="protection-learn-more" target="_blank">Learn More</a>
          <p class="protection-disclaimer">*Applies only to purchases, not consignments, sales or trades.</p>
          </center>
        </div>
        
      </div>
    `;
  },

  bindEvents() {
    const helpBtn = document.getElementById('protection-help-btn');
    const modal = document.getElementById('protection-modal');
    const closeBtn = document.getElementById('protection-modal-close');
    const checkbox = document.getElementById('protection-checkbox');

    if (helpBtn && modal) {
      helpBtn.onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        modal.classList.add('active');
      };
    }

    if (closeBtn && modal) {
      closeBtn.onclick = () => modal.classList.remove('active');
      modal.onclick = (e) => { if (e.target === modal) modal.classList.remove('active'); };
    }

    if (checkbox) {
      checkbox.onchange = async (e) => {
        if (this.isProcessing) return;

        const cart = await fetch('/cart.js').then(r => r.json());
        const fee = this.getFeeForCart(this.getCartTotalWithoutProtection(cart));

        if (e.target.checked) {
          await this.addProtection(this.variants[fee]);
        } else {
          const prot = this.getProtectionInCart(cart);
          if (prot) await this.removeProtection(prot.key);
        }
      };
    }
  },

  async init(autoAdd = false) {
    if (this.isInitializing || this.isProcessing) return;
    if (document.getElementById('shipping-protection')) return;

    this.isInitializing = true;

    try {
      const cart = await fetch('/cart.js').then(r => r.json()).catch(() => null);
      if (!cart) {
        this.isInitializing = false;
        return;
      }

      const realItems = cart.items.filter(item => !this.isProtectionItem(item));
      const realCount = realItems.length;

      if (realCount === 0) {
        const prot = this.getProtectionInCart(cart);
        if (prot) {
          await this.removeProtection(prot.key);
        }
        this.isInitializing = false;
        return;
      }

      // Check if ANY protection exists (polling will fix wrong tier)
      const allProtection = cart.items.filter(item => this.isProtectionItem(item));
      const hasProtection = allProtection.length > 0;
      const cartTotal = this.getCartTotalWithoutProtection(cart);
      const fee = this.getFeeForCart(cartTotal);
      const correctVariantId = this.variants[fee];

      const target = document.querySelector(
        '.cart-drawer #checkout, .cart-drawer [name="checkout"], ' +
        '.cart-drawer .cart__checkout-button, .cart-drawer .cart__ctas, ' +
        '.cart-drawer button[name="checkout"], .cart-drawer form[action="/checkout"], ' +
        '.drawer #checkout, .drawer [name="checkout"], .drawer .cart__ctas, ' +
        '#cart-drawer #checkout, #cart-drawer [name="checkout"], ' +
        '#CartDrawer #checkout, #CartDrawer [name="checkout"], ' +
        '#checkout, [name="checkout"], .cart__checkout-button, .cart__ctas'
      );

      if (!target) {
        this.isInitializing = false;
        return;
      }

      target.insertAdjacentHTML('beforebegin', this.renderUI(fee, hasProtection));
      this.bindEvents();

      // Only add protection if none exists AND autoAdd is true
      if (autoAdd && !hasProtection) {
        await this.addProtection(correctVariantId);
        const checkbox = document.getElementById('protection-checkbox');
        if (checkbox) checkbox.checked = true;
      }
    } finally {
      this.isInitializing = false;
    }
  }
};

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  ShippingProtection.init(false);
});

// Watch for add-to-cart button clicks
document.addEventListener('click', (e) => {
  const addBtn = e.target.closest('[data-add-to-cart], .add-to-cart, [name="add"], .product-form__submit, button[type="submit"][name="add"]');
  if (addBtn) {
    ShippingProtection.lastAddToCartTime = Date.now();
    setTimeout(() => ShippingProtection.init(true), 1000);
    setTimeout(() => ShippingProtection.init(true), 2000);
  }
});

// Listen for cart events
['cart:open', 'ajaxProduct:added'].forEach(evt => {
  document.addEventListener(evt, () => {
    const shouldAutoAdd = (Date.now() - ShippingProtection.lastAddToCartTime) < 3000;
    setTimeout(() => ShippingProtection.init(shouldAutoAdd), 500);
  });
});

// Poll for orphaned protection, duplicates, AND wrong tier
setInterval(async () => {
  if (document.hidden || ShippingProtection.isProcessing) return;

  ShippingProtection.isProcessing = true;
  try {
    const cart = await fetch('/cart.js').then(r => r.json()).catch(() => null);
    if (!cart) return;

    // Find ALL protection items
    const allProtection = cart.items.filter(item => ShippingProtection.isProtectionItem(item));
    const realCount = ShippingProtection.getRealItemCount(cart);
    const cartTotal = ShippingProtection.getCartTotalWithoutProtection(cart);
    const correctFee = ShippingProtection.getFeeForCart(cartTotal);
    const correctVariantId = ShippingProtection.variants[correctFee];

    // Remove ALL protection if no real items
    if (realCount === 0) {
      for (const p of allProtection) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: p.key, quantity: 0 })
        });
      }
      return;
    }

    // Check for duplicates or wrong tier
    const correctProtection = allProtection.find(p => String(p.variant_id) === correctVariantId);
    const wrongProtection = allProtection.filter(p => String(p.variant_id) !== correctVariantId);

    // Remove all wrong tier protection
    for (const p of wrongProtection) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: p.key, quantity: 0 })
      });
    }

    // If we removed wrong ones and don't have correct one, add it
    if (!correctProtection && wrongProtection.length > 0) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(correctVariantId), quantity: 1 })
      });
    }

    // Update the UI price display
    const priceEl = document.querySelector('.protection-price');
    if (priceEl) priceEl.textContent = `$${correctFee.toFixed(2)}`;
  } finally {
    ShippingProtection.isProcessing = false;
  }
}, 2000);

// OVERRIDE: Intercept remove button clicks to use item key instead of line number
document.addEventListener('click', async (e) => {
  const removeBtn = e.target.closest('cart-remove-button');
  if (!removeBtn) return;

  // Get the cart item row to find the item key
  const cartItem = removeBtn.closest('tr[data-cart-item-key]');
  if (!cartItem) return; // No key attribute, let default handle it

  const itemKey = cartItem.dataset.cartItemKey;
  if (!itemKey) return;

  // Prevent default behavior
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  // Show loading state
  const cartDrawerItems = removeBtn.closest('cart-drawer-items');
  const spinner = cartItem.querySelector('.loading__spinner');
  if (spinner) spinner.classList.remove('hidden');

  try {
    // Check if this is the last real item
    const cart = await fetch('/cart.js').then(r => r.json());
    const realItems = cart.items.filter(item => !ShippingProtection.isProtectionItem(item));
    const protection = ShippingProtection.getProtectionInCart(cart);

    // Remove the item using its key (not line number)
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: 0 })
    });

    // If this was the last real item and protection exists, remove protection too
    if (realItems.length === 1 && protection) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: protection.key, quantity: 0 })
      });
    }

    // Refresh the cart drawer
    if (cartDrawerItems && typeof cartDrawerItems.onCartUpdate === 'function') {
      cartDrawerItems.onCartUpdate();
    } else {
      // Manually refresh cart drawer section
      const response = await fetch(window.location.pathname + '?section_id=cart-drawer');
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newDrawerItems = doc.querySelector('cart-drawer-items');
      const newFooter = doc.querySelector('.cart-drawer__footer');
      if (newDrawerItems && cartDrawerItems) {
        cartDrawerItems.replaceWith(newDrawerItems);
      }
      const oldFooter = document.querySelector('.cart-drawer__footer');
      if (newFooter && oldFooter) {
        oldFooter.replaceWith(newFooter);
      }
    }
  } catch (err) {
    console.error('Remove item error:', err);
    if (spinner) spinner.classList.add('hidden');
  }
}, true); // Capture phase to intercept before theme's handler
